import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import IndexTargetIncentive from "../payrollManagement/incentive/IndexTargetIncentive";
import IndexCaseSheet from "./caseSheet/IndexCaseSheet";
import IndexMyCaseSheet from "./caseSheet/IndexMyCaseSheet";
import IndexMySubordinateCaseSheet from "./caseSheet/IndexMySubordinateCaseSheet";
import IndexCaseSheetApprovals from "./caseSheet/IndexCaseSheetApprovals";
import IndexTaskManagement from "./IndexTaskManagement";
import { guardElement } from "@comps/components";

const TaskManagementModules = () => {
  return (
    <Routes>
      <Route element={ <IndexTaskManagement /> }>
        <Route index element={ <Navigate to="caseSheet" replace /> } />
        <Route path="caseTargetIncentive" element={ guardElement(<IndexTargetIncentive modkey="case-target-incentive" />, "case-target-incentive") } />
        <Route path="caseSheet" element={ guardElement(<IndexCaseSheet modkey="case-sheet" />, "case-sheet") } />
        <Route path="myCaseSheet" element={ guardElement(<IndexMyCaseSheet modkey="my-case-sheet" />, "my-case-sheet") } />
        <Route path="mySubordinateCaseSheet" element={ guardElement(<IndexMySubordinateCaseSheet modkey="my-subordinate-case-sheet" />, "my-subordinate-case-sheet") } />
        <Route path="caseSheetApprovals" element={ guardElement(<IndexCaseSheetApprovals modkey="case-sheet-approvals" />, "case-sheet-approvals") } />
      </Route>
    </Routes>
  );
}

export default TaskManagementModules;
